module.exports = __webpack_public_path__ + "img/posture.fafa268d.png";